import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ZohoSettingsService } from './zoho-settings.service';
import { ZohoSettingsStore } from './zoho-settings.store';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../shared/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AccountSetupDialogComponent } from '../account-setup-dialog/account-setup-dialog.component';
import { ConfirmDialogComponent } from '../../shared';
import { takeUntil } from 'rxjs/operators';
import { INTEGRATION_IJ } from '../account-setup-dialog/account-setup-dialog.store';
import { MatButton } from '@angular/material/button';
import { NgIf, AsyncPipe, TitleCasePipe } from '@angular/common';
import { KeyValuePairComponent } from '../../shared/general/key-value-pair/key-value-pair.component';

@Component({
  selector: 'zoho-setup',
  templateUrl: './zoho-setup.component.html',
  providers: [
    ZohoSettingsService,
    ZohoSettingsStore,
    { provide: INTEGRATION_IJ, useValue: 'zoho' }
  ],
  standalone: true,
  imports: [KeyValuePairComponent, NgIf, MatButton, AsyncPipe, TitleCasePipe]
})
export class ZohoSetupComponent implements OnInit {
  status$ = this.store.status$;

  constructor(
    private router: Router,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private store: ZohoSettingsStore,
    private dialog: MatDialog,
    private toastService: ToastrService,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit(): void {
    if (
      this.route.snapshot.queryParams?.integration === 'zoho' &&
      this.route.snapshot.queryParams?.code
    ) {
      this.store.connectAccount(this.route.snapshot.queryParams?.code);
    }
  }

  attemptConnection() {
    this.store.attemptZohoConnection();
    throw new Error('test');
  }

  openAccountSetupDialog() {
    this.dialog.open(AccountSetupDialogComponent, {
      viewContainerRef: this.vcr
    });
  }

  disconnectConfirm() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Disconnect Zoho',
          message: 'Are you sure you want to disconnect Zoho?'
        },
        maxWidth: '600px'
      })
      .afterClosed()
      .pipe(takeUntil(this.store.destroy$))
      .subscribe((result) => {
        if (result) {
          this.store.disconnect();
        }
      });
  }
}
